import React from "react";
import { ShieldCheck, Award } from "lucide-react";
import { IMG } from "../lib/constants";

const AWARDS = [
    { src: IMG.award2, alt: "Karnataka Department of Tourism Certificate of Registration", label: "Karnataka State Tourism" },
    { src: IMG.award1, alt: "Restaurant Guru Recommended 2023", label: "Restaurant Guru · 2023" },
    { src: IMG.award4, alt: "Restaurant Guru Recommended 2022", label: "Restaurant Guru · 2022" },
    { src: IMG.award3, alt: "Justdial Users' Choice 2025", label: "Justdial Users' Choice · 2025" },
];

export default function Awards() {
    return (
        <section id="awards" className="relative bg-cream border-b border-sand py-16 md:py-20" data-testid="awards-section">
            <div className="max-w-6xl mx-auto px-6 md:px-10">
                {/* Approval line */}
                <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-5 text-center md:text-left mb-10 md:mb-14">
                    <span className="inline-flex items-center justify-center h-11 w-11 rounded-full bg-forest-700/10 text-forest-700 shrink-0">
                        <ShieldCheck className="h-5 w-5" />
                    </span>
                    <p className="text-coffee-800 text-sm md:text-base max-w-3xl">
                        <span className="font-serif italic text-[#B98E4E]">Officially recognised.</span>{" "}
                        Veeras Western Ghats is{" "}
                        <span className="font-medium text-forest-700">recommended &amp; approved by Karnataka State Tourism</span>{" "}
                        — and trusted by India's leading review platforms.
                    </p>
                </div>

                {/* Heading */}
                <div className="text-center mb-10">
                    <p className="text-xs tracking-[0.3em] uppercase text-forest-700 mb-3 inline-flex items-center gap-2 justify-center">
                        <Award className="h-3.5 w-3.5" /> Our recognitions
                    </p>
                    <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-coffee-900 font-light leading-tight">
                        Awarded for <span className="italic text-forest-700">customer love.</span>
                    </h2>
                </div>

                {/* Award grid — 4 uniform cards */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                    {AWARDS.map((a, i) => (
                        <figure
                            key={a.label}
                            className="group bg-white border border-sand rounded-2xl p-3 md:p-4 hover:-translate-y-1 hover:shadow-lg transition-all duration-500"
                            data-testid={`award-card-${i}`}
                        >
                            <div className="aspect-square rounded-xl overflow-hidden bg-cream">
                                <img
                                    src={a.src}
                                    alt={a.alt}
                                    className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-[900ms]"
                                />
                            </div>
                            <figcaption className="mt-3 text-center text-[11px] md:text-xs tracking-[0.18em] uppercase text-coffee-700 leading-snug">
                                {a.label}
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
